var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "parent-dashboard" } },
    [
      _c(
        "panel-basic",
        {
          attrs: {
            title: _vm.$t("MAIN_CONTENT.ParentHomePage.myStudents"),
            id: "myStudents",
            collapsable: false
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            !!_vm.selectedStudent
              ? _c(
                  "div",
                  { staticClass: "col-lg-5 col-md-7 student-information-wrap" },
                  [
                    _c("div", { staticClass: "inline-block" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-5 col-sm-6 student-pic" },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              staticStyle: { cursor: "pointer" },
                              attrs: {
                                src: _vm.selectedStudent.PHOTO_URL,
                                alt: _vm.selectedStudent.NAME
                              },
                              on: { click: _vm.setSelectedStudent }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-7 col-sm-6 student-info" },
                          [
                            _c("h2", [
                              _vm._v(
                                _vm._s(
                                  _vm.selectedStudent.FIRST_NAME +
                                    " " +
                                    _vm.selectedStudent.LAST_NAME
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.ParentHomePage.homePhoneNumberTitleCaseWithColon"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("phone")(
                                      _vm.selectedStudent.PHONE_NO
                                    )
                                  ) +
                                  " "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.ParentHomePage.emailWithColon"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.selectedStudent.EMAIL_ADDRESS) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "pointer",
                                on: { click: _vm.changeStudentData }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    "aria-hidden": "true",
                                    icon: "file-signature"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {}, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.ChangeStudentData.sideMenuChangeStudentDataLink"
                                        )
                                      ) +
                                      " "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br")
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-backpack",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.setSelectedStudent }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.ParentHomePage.goToMyBackpack",
                                          {
                                            name: _vm.selectedStudent.FIRST_NAME
                                          }
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row school-information" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-md-5 school-logo",
                            staticStyle: { "margin-top": "20px" }
                          },
                          [
                            _c("img", {
                              staticClass: "img-fluid",
                              attrs: {
                                src: _vm.districtImage.DISTRICT_LOGO_URL,
                                alt: "Institute"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-7" },
                          _vm._l(_vm.selectedStudent.ENROLLMENT, function(
                            school
                          ) {
                            return _c("div", { key: school.SCHOOL_ID }, [
                              _c("h2", [_vm._v(_vm._s(school.SCHOOL_TITLE))]),
                              _vm._v(" "),
                              _c("p", [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.commonContent.sideMenuGradeLabel"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" " + _vm._s(school.GRADE_LEVEL) + " "),
                                _c("br"),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.ParentHomePage.schoolContactTitleCaseWithColon"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("phone")(
                                        school.SCHOOL_PHONE_NUMBER
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-7 col-md-5" }, [
              _c("fieldset", { staticClass: "goto" }, [
                _c(
                  "div",
                  { staticClass: "flex-container-wrap" },
                  _vm._l(_vm.students, function(student, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "select-student" },
                      [
                        _c("div", { staticClass: "text-center" }, [
                          _c("img", {
                            staticClass: "student-pic-dash",
                            staticStyle: { width: "135px", cursor: "pointer" },
                            attrs: {
                              src: student.PHOTO_URL,
                              alt: student.NAME
                            },
                            on: {
                              click: function($event) {
                                return _vm.quickView(student)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("h3", [
                            _vm._v(
                              _vm._s(
                                student.FIRST_NAME + " " + student.LAST_NAME
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                disabled:
                                  _vm.selectedStudent.STUDENT_RID ===
                                  student.STUDENT_RID
                              },
                              on: {
                                click: function($event) {
                                  return _vm.quickView(student)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: {
                                  icon: "search-plus",
                                  "aria-hidden": "true"
                                }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.ParentHomePage.quickViewTitleCase"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }